import { _Object } from './object';
import { DomainV2 as _DomainV2 } from './v2';
// import { _Service } from './service';

export namespace Domain {
  export import Object = _Object;
  // export import Service = _Service;
}

export { _DomainV2 as DomainV2 };
